import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { AiAssistantPromptPreset } from '@domain/ai-assistant/ai-assistant.models';
import { AI_SUGGESTION_KEYS } from '@domain/ai-assistant/ai-suggestions';

import { appAi52Icon } from '@icons/ai-52';
import { appArrowsIn32Icon } from '@icons/arrows-in-32';
import { appCloseV224Icon } from '@icons/close-v2-24';

import { AiAssistantService } from '../../ai-assistant.service';
import { AiAssistantPromptPresetsComponent } from '../ai-assistant-prompt-presets/ai-assistant-prompt-presets.component';
import { AiAssistantSidebarComponent } from '../ai-assistant-sidebar/ai-assistant-sidebar.component';
import { AiComposerComponent, AiComposerMessage } from '../ai-composer/ai-composer.component';
import { AiMessageListComponent } from '../ai-message-list/ai-message-list.component';

@Component({
  selector: 'app-ai-assistant-fullscreen',
  imports: [
    TranslatePipe,
    SvgIconComponent,
    AiAssistantSidebarComponent,
    AiMessageListComponent,
    AiComposerComponent,
    AiAssistantPromptPresetsComponent,
  ],
  templateUrl: './ai-assistant-fullscreen.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col overflow-hidden relative bg-[#EDEFF7] dark:bg-background-main z-0' },
})
export class AiAssistantFullscreenComponent {
  public readonly aiService = inject(AiAssistantService);
  public readonly suggestionKeys = AI_SUGGESTION_KEYS;
  public readonly composerValue = signal('');

  constructor() {
    injectRegisterIcons([appAi52Icon, appArrowsIn32Icon, appCloseV224Icon]);
  }

  public onMinimize(): void {
    this.aiService.collapse();
  }

  public onClose(): void {
    this.aiService.close();
  }

  public onSuggestionClicked(text: string): void {
    if (!this.composerValue().trim()) {
      this.composerValue.set(text);
    }
  }

  public onMessageSent(message: AiComposerMessage): void {
    this.aiService.send(message.message, message.uiContext);
  }

  public onPromptPresetSelected(promptPreset: AiAssistantPromptPreset): void {
    this.aiService.runPromptPreset(promptPreset);
  }
}
